export class LoginUser {
  public email!: string;
  public password!: string;

  constructor(values?: LoginUser) {
    Object.assign(this, values);
  }
}
